export default "__VITE_ASSET__gAv4IbYN__"